import i18n from 'i18next';

export function formatMonth(value: string, isExamplePage: boolean = false) {
  const onlyNumber = value.split(' ');
  const num = Number(onlyNumber[0]);
  if (!value.trim() || isNaN(num)) return '';

  const lang = i18n.language;

  if (lang === 'uk' && !isExamplePage) {
    const lastDigit = num % 10;
    const lastTwoDigits = num % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
      return `${num} місяців`;
    }

    if (lastDigit === 1) {
      return `${num} місяць`;
    }

    if (lastDigit >= 2 && lastDigit <= 4) {
      return `${num} місяці`;
    }

    return `${num} місяців`;
  }

  if (lang === 'en' || isExamplePage) {
    return `${num} ${num === 1 ? 'month' : 'months'}`;
  }

  if (lang === 'de' && !isExamplePage) {
    return `${num} ${num === 1 ? 'Monat' : 'Monate'}`;
  }

  return `${num} months`;
}
